import { Component } from "react"
import { Components } from "../../Components";
import { ComponentsContext } from "../ComponentsProvider/ComponentsProvider";

export abstract class BaseComponent<TProps, TState> extends Component<TProps, TState>
{
    public static contextType = ComponentsContext;
    public declare context: Components;

    protected get components(): Components
    {
        if (!this.context)
        {
            throw new Error("BaseComponent must be used within a ComponentsProvider");
        }
        return this.context;
    }

    private _pendingState: TState | null = null;
    public get pendingState() { return this._pendingState ?? this.state }

    public setStateAsync<K extends keyof TState>(
        state:
            | ((prevState: Readonly<TState>, props: Readonly<TProps>) => (Pick<TState, K> | TState | null))
            | (Pick<TState, K> | TState | null)
    ): Promise<void>
    {
        return new Promise(resolve =>
        {
            this.setState(state, () =>
            {
                this._pendingState = null;
                resolve();
            });
            this._pendingState = { ...this.pendingState, ...state };
        });
    }
}

export default BaseComponent;
